import { motogpMail } from "../../../constants/accounts";

const ALPHANUMERIC_RE = /^[\w]+$/;
const EMAIL_RE = /^[\w-.]+@([\w-]+\.)+[\w]+$/;

const isAlphanumericMin4 = (value: string): boolean =>
  value.length > 3 && ALPHANUMERIC_RE.test(value);

const minLengthAlphanumericMessage = (noun: string): string =>
  `${noun} must be at least 4 characters long and contain only letters and numbers.`;

export const requiredValidator = (value: string): string => (value ? '' : 'This field is required.');

export const passwordValidator = (value: string): string =>
  value
    ? isAlphanumericMin4(value) ? '' : minLengthAlphanumericMessage('Password')
    : 'This field is required.';

export const requiredArrayValidator = (value: any[]): string => (value && value.length > 0 ? '' : 'This field is required.');

export const emailValidator = (value: string): string => (EMAIL_RE.test(value) ? '' : 'Please enter a valid email.');
export const accountValidator = (value: string): string =>
  isAlphanumericMin4(value) ? '' : minLengthAlphanumericMessage('Username');
export const emailOrAccountValidator = (value: string): string =>  value === null || value === undefined
                                                                        ? 'This field is required.'
                                                                        : value.includes("@") ? emailValidator(value) : accountValidator(value);

export const isDornaUser = (value: string) :boolean => value.endsWith(motogpMail);


